import { Injectable } from '@angular/core';
import { Order } from '../../../models/order';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductionOrderService {
  constructor(protected http: HttpClient) { }

  public create(order: Order): Observable<Order> {
    return this.http.post<Order>('json/production/orders', order);
  }

}
